import Classic from "./variants/Classic";
import Leave from "./variants/Leave";

export default {
  Classic,
  Leave
}